if (!customElements.get('yc-new-drops')) {
  class YCNewDrops extends HTMLElement {
    connectedCallback() {
      this.squares = Array.from(this.querySelectorAll('.yc-nd__square[data-target-id]'));
      this.blocks = this.querySelectorAll('.yc-nd__block-content');
      
      this.autoPlayEnabled = this.dataset.autoPlay === 'true';
      this.autoPlayInterval = parseInt(this.dataset.autoPlayInterval) * 1000 || 5000;
      this.autoPlayTimer = null;
      this.currentIndex = 0;

      this.init();
    }

    switchToIndex(index) {
      if (!this.squares.length) return;
      
      this.squares.forEach(s => s.classList.remove('is-active'));
      this.blocks.forEach(b => b.classList.remove('is-active'));

      const square = this.squares[index];
      square.classList.add('is-active');
      
      const targetId = square.getAttribute('data-target-id');
      const targetBlock = this.querySelector(`.yc-nd__block-content[data-block-id="${targetId}"]`);
      if (targetBlock) {
        targetBlock.classList.add('is-active');
      }
      
      const scrollArea = this.querySelector('.yc-nd__scroll-area');
      if (scrollArea) {
        const scrollAreaRect = scrollArea.getBoundingClientRect();
        const squareRect = square.getBoundingClientRect();
        const targetScrollTop = scrollArea.scrollTop + (squareRect.top - scrollAreaRect.top) - (scrollArea.clientHeight / 2) + (squareRect.height / 2);
        
        scrollArea.scrollTo({
          top: targetScrollTop,
          behavior: 'smooth'
        });
      }
    }

    startAutoPlay() {
      if (!this.autoPlayEnabled || this.squares.length <= 1) return;
      this.stopAutoPlay();
      this.autoPlayTimer = setInterval(() => {
        this.currentIndex = (this.currentIndex + 1) % this.squares.length;
        this.switchToIndex(this.currentIndex);
      }, this.autoPlayInterval);
    }

    stopAutoPlay() {
      if (this.autoPlayTimer) {
        clearInterval(this.autoPlayTimer);
        this.autoPlayTimer = null;
      }
    }

    init() {
      this.squares.forEach((square, index) => {
        if (square.classList.contains('is-active')) {
          this.currentIndex = index;
        }
        square.addEventListener('click', () => {
          this.currentIndex = index;
          this.switchToIndex(this.currentIndex);
          if (this.autoPlayEnabled) {
            this.stopAutoPlay();
            this.startAutoPlay();
          }
        });
      });

      if (this.autoPlayEnabled) {
        this.addEventListener('mouseenter', this.stopAutoPlay.bind(this));
        this.addEventListener('mouseleave', this.startAutoPlay.bind(this));
        this.startAutoPlay();
      }

      document.addEventListener('shopify:block:select', (event) => {
        const blockId = event.detail.blockId;
        const targetBlock = this.querySelector(`.yc-nd__block-content[data-block-id="${blockId}"]`);
        if (targetBlock) {
          const index = this.squares.findIndex(s => s.getAttribute('data-target-id') === blockId);
          if (index !== -1) {
            this.currentIndex = index;
            this.switchToIndex(this.currentIndex);
          }
        }
      });
    }
  }
  customElements.define('yc-new-drops', YCNewDrops);
}
